var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tsstart
    ? _c("span", { staticClass: "ts-start" }, [
        _vm.isDateToday(_vm.tsstart)
          ? _c("span", [
              _vm._v(
                _vm._s(_vm.$t("BettingOffer.Today")) +
                  " " +
                  _vm._s(
                    _vm._f("moment")(_vm.tsstart, _vm.dateFormats.longTime)
                  )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isDateTomorrow(_vm.tsstart)
          ? _c("span", [
              _vm._v(
                _vm._s(_vm.$t("BettingOffer.Tomorrow")) +
                  " " +
                  _vm._s(
                    _vm._f("moment")(_vm.tsstart, _vm.dateFormats.longTime)
                  )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isDateToday(_vm.tsstart) && !_vm.isDateTomorrow(_vm.tsstart)
          ? _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("moment")(_vm.tsstart, _vm.dateFormats.longDateTimeMG)
                ) + " "
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b0e838f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b0e838f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tsStart.vue
// module id = null
// module chunks = 